import React, { useEffect, useState } from 'react';
import { fetchProjectsData } from './Data';
import WorkItem from './WorkItems';
import './work.css';

const Work = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchProjectsData();
      setProjects(data);
    };
    fetchData();
  }, []);

  const handleNext = () => {
    const items = document.querySelectorAll('.work__item');
    document.querySelector('.work__slide').appendChild(items[0]);
  };

  const handlePrev = () => {
    const items = document.querySelectorAll('.work__item');
    document.querySelector('.work__slide').prepend(items[items.length - 1]);
  };

  return (
    <section className="work section" id="portfolio">
      <h2 className="section__title">Portfolio</h2>
      <span className="section__subtitle">Showcase of Most Recent Projects</span>

      <div className="work__container container">
        <div className="work__slide">
          {projects.map((item) => (
            <WorkItem
              key={item.id}
              imgUrl={item.image}
              title={item.title || ''}
              description={item.description || ''}
              demoLink={item.details_link}
              codeLink={item.source_code_link}
              category={item.category}
              tech={Array.isArray(item.tech) ? item.tech : JSON.parse(item.tech || '[]')}
              platform={Array.isArray(item.platform) ? item.platform : JSON.parse(item.platform || '[]')}
            />
          ))}
        </div>

        <div className="work__buttons-nav">
          <button className="prev" onClick={handlePrev}>
            <i className="uil uil-angle-left"></i>
          </button>
          <button className="next" onClick={handleNext}>
            <i className="uil uil-angle-right"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Work;